import {Component, OnDestroy, OnInit} from '@angular/core';
import {TemplateService} from '../../services/template.service';
import {Chart} from 'chart.js';
import * as _ from 'lodash';
import {ApiService} from '../../services/api.service';
import {HttpParams} from '@angular/common/http';
import {NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
import * as moment from 'moment';
import {CALENDAR_LOCALE} from '../../services/constant';
import {Subscription} from "rxjs";

@Component({
  selector: 'app-email-dashboard',
  templateUrl: './email-dashboard.component.html',
  styleUrls: ['./email-dashboard.component.scss'],
  providers: [TemplateService]
})
export class EmailDashboardComponent implements OnInit, OnDestroy {

  modal: NgbModalRef;
  currentPage = 1;
  itemsPerPage = 40;
  totalItems = 0;
  transactions_sent: any;
  transactions_failed: any;
  transactions_wait_for_send: any;
  transactions_not_sent: any;
  sentChart: Chart;
  errorChart: Chart;
  emailTotal;
  emailSent: number = 0;
  emailSendFailed: number = 0;
  data;
  status;
  allBuyerEmailsReport = null;
  docType;
  myChart1;
  myChart2;
  loading;
  loading_main = false;
  tableData = [];
  selectedCompany = null;
  company: any;
  branch: any;
  branchList: any = null;
  selectedBranch = null;
  allBranchList: any = null;
  startDate: Date = null;
  endDate: Date = null;
  minDate: Date;
  maxDate: Date;
  calendarLocale = CALENDAR_LOCALE.TH;
  rdDocumentType: any;
  selectedRdDocumentType: any;
  documentType: any;
  documentNumber: any;
  email: any;
  sortBy = null;
  sortMode = null;
  sentdata = null;
  searching: boolean = false;
  tableCol = [];
  subs: Subscription;

  constructor(private apiService: ApiService,
              private translate: TranslateService,
              private template: TemplateService) {
  }

  ngOnInit() {
    this.startDate = new Date();
    this.startDate.setDate(this.startDate.getDate() - 60);
    this.endDate = new Date();
    this.subs = this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.loadInitData();
      this.searchButtonClicked();
    });
    this.loadInitData();
    this.searchButtonClicked();
  }

  get currentLang(): string {
    return this.translate.currentLang;
  }

  generateChart() {
    this.sentChart = new Chart('sentChart', {
      type: 'doughnut',
      data: {
        datasets: [{
          label: 'Sent Chart',
          data: [this.emailSent, this.emailSendFailed],
          backgroundColor: [
            '#16c8c8',
            '#5b5a5a',
          ],
          borderColor: [
            '#ededed',
            '#ededed',
          ],
          borderWidth: 1
        }]
      },
      options: {
        responsive: true,
        tooltips: {
          enabled: false,
        },
        cutoutPercentage: 60
      }
    });

    this.errorChart = new Chart('errorChart', {
      type: 'doughnut',
      data: {
        datasets: [{
          label: 'Failed Chart',
          data: [this.emailSendFailed, this.emailSent],
          backgroundColor: [
            '#FF6384',
            '#6F6E6E'
          ],
          borderColor: [
            '#ededed',
            '#ededed',
          ],
          borderWidth: 1
        }]
      },
      options: {
        tooltips: {
          enabled: false,
        },
        cutoutPercentage: 60
      }
    });
  }

  sort(event) {
    this.sortBy = event.field;
    if (event.order === 1) {
      this.sortMode = '';
    } else {
      this.sortMode = '-';
    }
  }

  pageChanged() {
    this.sentdata = 1;
    this.loadData(this.currentPage);
  }

  searchButtonClicked() {
    this.currentPage = 1;
    this.sortBy = null;
    this.sortMode = null;
    this.status = null;
    this.loadData();
  }

  loadInitData() {
    if (this.translate.currentLang === 'en') {
      this.calendarLocale = CALENDAR_LOCALE.EN;
    } else {
      this.calendarLocale = CALENDAR_LOCALE.TH;
    }
    this.loading_main = true;

    this.rdDocumentType = this.template.getDropdown();
    this.company = [{
      label: this.translate.instant('COMMON.ALL'),
      value: null
    }];
    this.branchList = [{
      label: this.translate.instant('COMMON.ALL'),
      value: null
    }];

    this.apiService.getCompany().subscribe(
      (result) => {
        _.forEach(result, (obj) => {
          this.company.push({
            label: obj.name,
            value: obj.id
          });
        });
        this.company = _.uniqBy(this.company, 'label');
      },
      error => error(status)
    );

    this.apiService.getBranch().subscribe(
      (result) => {
        this.allBranchList = result;
        this.filterBranchList();
      }
    );

    this.apiService.getAllBuyerEmailsReport().subscribe(
      (result) => {
        this.allBuyerEmailsReport = result.all_buyer_emails_report;
      }
    );

    this.translate.get('COMMON.ALL').subscribe((res: string) => {
      this.tableCol = [];

      this.tableCol.push(
        {field: 'created_at', header: this.translate.instant('EMAIL-DASHBOARD.SENT-DATE')},
        {field: 'tax_data__header_invoice_number', header: this.translate.instant('FILTER.DOCUMENT-NUMBER')},
        {field: 'tax_data__rd_document_type', header: this.translate.instant('FILTER.DOCUMENT-TYPE')},
      );
      this.tableCol = _.uniqBy(this.tableCol, 'field');
    });

  }

  filterStatus(data?) {
    this.currentPage = 1;
    this.status = data;
    this.loadData(this.currentPage, this.status);
  }


  loadData(page?, data?) {
    this.tableData = [];
    let params = new HttpParams();
    if (this.selectedCompany && this.selectedRdDocumentType) {
      params = params.append('corporate', this.selectedCompany);
      params = params.append('document_type', this.selectedRdDocumentType);
    }
    if (this.status) {
      params = params.append('status', this.status);
    }
    if (this.selectedCompany) {
      params = params.append('corporate', this.selectedCompany);
    }
    if (this.selectedBranch) {
      params = params.append('corporate_branch', this.selectedBranch);
    }
    if (this.selectedRdDocumentType) {
      params = params.append('document_type', this.selectedRdDocumentType);
    }
    if (this.documentNumber) {
      params = params.append('document_number', this.documentNumber);
    }
    if (this.email) {
      params = params.append('email', this.email);
    }
    if (this.sentdata) {
      params = params.append('page', this.currentPage.toString());
      params = params.append('page_size', this.itemsPerPage.toString());
    }
    if (this.startDate) {
      params = params.append('start_date', moment(this.startDate).format('YYYY-MM-DD'));
    }
    if (this.endDate) {
      params = params.append('end_date', moment(this.endDate).format('YYYY-MM-DD'));
    }
    if (this.sortBy) {
      params = params.append('ordering', this.sortMode + this.sortBy);
    }
    this.apiService.getEmailDashboard(params).subscribe((result) => {
      _.forEach(result.results, (obj) => {
        this.tableData.push({
          sent_date: obj.sent_date,
          document_number: obj.document_number,
          document_type: obj.document_type_display,
          document_type_th: obj.document_type_display_th,
          to_email_data: obj.to_email,
          cc_email_data: obj.cc_email,
          status: obj.status,
        });
      });
      this.totalItems = result.count;
      this.emailSent = result.email_sent;
      this.emailSendFailed = result.email_failed;
      this.emailTotal = result.email_sent + result.email_failed;
      this.transactions_sent = result.transactions_sent;
      this.transactions_failed = result.transactions_failed;
      this.transactions_wait_for_send = result.transactions_wait_for_send;
      this.transactions_not_sent = result.transactions_not_sent;
      this.loading_main = false;
      if (!this.sentChart && !this.errorChart) {
        this.generateChart();
      } else {
        this.sentChart.destroy();
        this.errorChart.destroy();
        this.generateChart();
      }

      this.loading_main = false;
    });
    this.loading_main = false;
  }

  get yearRange() {
    const thisYear = (new Date()).getFullYear();
    return (thisYear - 40) + ':' + thisYear;
  }

  get dateRange() {
    if (!this.startDate && !this.endDate) {
      return null;
    }

    const start = this.startDate ? moment(this.startDate).format('DD/MM/YYYY') : '';
    const end = this.endDate ? moment(this.endDate).format('DD/MM/YYYY') : '';
    return start + ' - ' + end;
  }

  setMinDate() {
    this.minDate = this.startDate;
  }

  setMaxDate() {
    this.maxDate = this.endDate;
  }

  clearData() {
    this.transactions_failed = null;
    this.transactions_wait_for_send = null;
    this.transactions_not_sent = null;
    this.transactions_sent = null;
    this.tableData = null;
    this.startDate = new Date();
    this.startDate.setDate(this.startDate.getDate() - 60);
    this.endDate = new Date();
    this.rdDocumentType = null;
    this.branchList = null;
    this.company = null;
    this.selectedCompany = null;
    this.selectedRdDocumentType = null;
    this.email = null;
    this.sortBy = null;
    this.sortMode = null;
    this.totalItems = 0;
    this.currentPage = 1;
    this.selectedBranch = null;
    this.documentNumber = null;
    this.loadInitData();
    this.searchButtonClicked();
  }

  filterBranchList() {
    this.selectedBranch = null;

    this.branchList = [{
      label: this.translate.instant('COMMON.ALL'),
      value: null
    }];

    _.forEach(this.allBranchList, (obj) => {
      if (this.selectedCompany === null || obj.corporate === this.selectedCompany) {
        this.branchList.push({
          label: obj.full_name,
          value: obj.id
        });
      }
    });
  }

  stopPropagation(event) {
    event.stopPropagation();
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/email-dashboard/email-dashboard.component.ts